import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  SFDatagrid,
  SFActionBar,
  SFPageContainer,
  ACTION_BAR_ACTION_TYPES,
  ACTION_BAR_ACTION_NAMES,
} from "@sf-core";
import { PATHS } from "../../constants/paths";
import getNavDefs from "../navDefs/getSkillsExtractionNavDefs";
import { useSelector } from "react-redux";
import { API_PARAM } from "../../constants/apiParams";
import { GridNames } from "../../constants/gridConfig";
import { Claims } from "../../constants/claims";
import {
  exportNegativeTextGrid,
  uploadFromNegativeText,
} from "../../services/negativeTextService";

const NegativeText = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const navDefs = getNavDefs({ t });

  const negativeTextGridLayout = useSelector((state) =>
    state.gridLayout.find((grid) => grid.gridName === GridNames.NEGATIVE_TEXT)
  );

  const handleNegativeTextDownload = () => {
    exportNegativeTextGrid(negativeTextGridLayout?.filterModel ?? {});
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: t("negativeTextScreen.negativeTextGrid.microSkillIdColumn"),
        field: "microSkillId",
        hide: false,
      },
      {
        headerName: t(
          "negativeTextScreen.negativeTextGrid.microSkillNameColumn"
        ),
        field: "microSkillName",
        filter: true,
        filterParams: {
          order: 1,
        },
      },
      {
        headerName: t("negativeTextScreen.negativeTextGrid.negativeTextColumn"),
        field: "negativeText",
        filter: true,
        filterParams: {
          order: 2,
        },
      },
    ],
    []
  );

  const actionDefs = [
    {
      name: ACTION_BAR_ACTION_NAMES.ADD,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      permissions: [Claims.AdminDataSkillExtractionImport],
      onClick: () => navigate(PATHS.NEGATIVE_TEXT_PATH_ADD),
      buttonProps: {
        label: t("manageSkillsExtractionScreen.addNegativeTextBtn"),
        variant: "primary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.DOWNLOAD,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      permissions: [Claims.AdminDataSkillExtractionExport],
      onClick: handleNegativeTextDownload,
      iconProps: {
        tooltip: t("analyticsSkillExtractionRoutes.download.negativeText"),
        overflowLabel: t(
          "analyticsSkillExtractionRoutes.download.negativeText"
        ),
      },
    },
    {
      name: "submitNegativeText",
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: uploadFromNegativeText,
      buttonProps: {
        label: t("analyticsSkillExtractionRoutes.submitButtonLabel"),
        variant: "primary",
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        message: t("benchmark.submitDictionaryButton.submitMessage"),
        header: t("benchmark.submitDictionaryButton.submitHeader"),
        primaryLabel: t("benchmark.submitDictionaryButton.submitConfirm"),
        secondaryLabel: t("benchmark.submitDictionaryButton.submitCancel"),
      },
      permissions: [Claims.AdminDataSkillExtractionUpload],
    },
    {
      name: ACTION_BAR_ACTION_NAMES.FILTER,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      filterParams: {
        gridName: GridNames.NEGATIVE_TEXT,
      },
    },
  ];

  return (
    <>
      <SFPageContainer disableGutters>
        <SFActionBar
          titleProps={{
            title: t("analyticsSkillExtractionRoutes.negativeText"),
          }}
          actionDefs={actionDefs}
          navDefs={navDefs}
        />
        <SFDatagrid
          fitScreen
          canDownload={false}
          columnDefs={columnDefs}
          gridName={GridNames.NEGATIVE_TEXT}
          datasourceUrl={API_PARAM.NEGATIVE_TEXT_GRID}
          filterValuesUrl={API_PARAM.NEGATIVE_TEXT_COL_FILTER}
          basicFiltering
        />
      </SFPageContainer>
    </>
  );
};

export default NegativeText;
